import { render, staticRenderFns } from "./Card-img-test.vue?vue&type=template&id=1288f4b5&scoped=true&"
import script from "./Card-img-test.vue?vue&type=script&lang=js&"
export * from "./Card-img-test.vue?vue&type=script&lang=js&"
import style0 from "./Card-img-test.vue?vue&type=style&index=0&id=1288f4b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288f4b5",
  null
  
)

export default component.exports